import { render, staticRenderFns } from "./RemoteConsultationDealView.vue?vue&type=template&id=6163d543&"
import script from "./RemoteConsultationDealView.vue?vue&type=script&lang=js&"
export * from "./RemoteConsultationDealView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports